import {getUrlParams, StorageUtils} from 'xmgoing-utils';

export function useAppLoading(){
  const loadingFlag=ref(false);

  const sessionId = getUrlParams('sessionId', true) || StorageUtils.getItem('access_token');
  if (sessionId) {
    StorageUtils.addItem('access_token', sessionId);
  }

  StorageUtils.addSessionItem('running', 'true');
  StorageUtils.addSessionItem('showApp', 'false');

  //关闭窗口的定时
  let closeTimer:any=null;
//显示loading
  const showLoading=function (){
    loadingFlag.value=true;
    //防止错误 没有调用loading 则通过定时器来进行关闭
    if(closeTimer){
      clearTimeout(closeTimer)
    }
    closeTimer=setTimeout(()=>{
      loadingFlag.value=false;
    },6000)
  }
//关闭loading
  const hideLoading = () => {
    loadingFlag.value=false;
  }

  return {
    showLoading,
    hideLoading,
    loadingFlag
  }
}
